import { render, staticRenderFns } from "./SubjectDocumentListCard.vue?vue&type=template&id=5fac09ca"
import script from "./SubjectDocumentListCard.vue?vue&type=script&lang=js"
export * from "./SubjectDocumentListCard.vue?vue&type=script&lang=js"
import style0 from "./SubjectDocumentListCard.vue?vue&type=style&index=0&id=5fac09ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SubjectDocumentListCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports